import { CombinedReducerStore } from "../store";
import { getParameterFromUrl } from "./utils"
import { fbLogin } from "../gateway/facebook";
import { googleLogin } from "../gateway/google";
import { authCallback, postAuthCallback, currentUser, currentUserOfAccount, logOutUser } from "../gateway/api";

export function login(accountName, params={}) {
  return fbLogin()
    .then((response) => authCallback("facebook", params))
    .then((response) => {
      if(response.current_user && params['userLogin']) {
        params.userLogin()
      }
      if(window.ga && accountName) {
	ga('send', 'event', accountName, 'CommentWidgetFacebookLogin', getParameterFromUrl('page_url'));
      }
      CombinedReducerStore.dispatch({type: "LOGIN_SETUSER", currentUser: response.current_user, signedIn: response.success})
      if(response["sso_redirect_uri"]) {
	window.location.href =  response["sso_redirect_uri"]
      }
    });
}

export function loginWithGoogle(accountName, params={}) {
  return googleLogin()
    .then((response) => postAuthCallback("google_oauth2", Object.assign(response, params)))
    .then((response) => {
      if(response.current_user && params['userLogin']) {
        params.userLogin()
      }
      if (window.ga && accountName) {
	ga('send', 'event', accountName, 'CommentWidgetGoogleLogin', getParameterFromUrl('page_url'));
      }
      CombinedReducerStore.dispatch({type: "LOGIN_SETUSER", currentUser: response.current_user, signedIn: response.success})
      if(response["sso_redirect_uri"]) {
	window.location.href =  response["sso_redirect_uri"]
      }
    });
}

export function logout(loginObj={}) {
  if (accountLogin()) {
    CombinedReducerStore.dispatch({type: 'LOGIN', ...loginObj, email: "", password: ""});
    CombinedReducerStore.dispatch({type: 'SCREEN', screen: 'signin'});
    CombinedReducerStore.dispatch({type: "LOGIN_CLEAR", signedIn: false})
    setCurrentUser(null);
    return Promise.resolve();
  }
  return logOutUser()
  .then((response) => {
    if(window.ga) {
      let config = talktype.config || metype.config;
      const accountName = (config && config.account && config.account.name) || "Metype";
      ga('send', 'event', accountName, 'CommentWidgetLogout',  getParameterFromUrl('page_url'));
    }
    CombinedReducerStore.dispatch({type: 'LOGIN', ...loginObj, email: "", password: ""});
    CombinedReducerStore.dispatch({type: 'SCREEN', screen: 'signin'});
    CombinedReducerStore.dispatch({type: "LOGIN_CLEAR", signedIn: false})
  });
}

function accountLogin() {
    let config = talktype.config || metype.config,
        configurations = (config.account && config.account['configurations']) || '';
    return configurations && configurations.find((config) => config.name == 'account_login');
}

function setCurrentUser(user) {
  let currentConfig = talktype || metype;
  currentConfig.currentUser = user;
}

export function checkIfLoggedIn(params = {}) {
  if (accountLogin()) {
    if (params.user) {
      return currentUserOfAccount(params.user.jwt)
             .then((response) => {
               let currentUserWithJWT = Object.assign(response.current_user, { jwt: params.user.jwt })
                CombinedReducerStore.dispatch({
                  type: "LOGIN_SETUSER",
                  currentUser: currentUserWithJWT,
                  signedIn: response.signed_in
                })
                setCurrentUser(currentUserWithJWT);
             });
    } else {
      return Promise.resolve();
    }
  } else {
    return currentUser()
          .then((response) => {
            if(response.current_user && params.userLogin) {
              params.userLogin();
            }
            CombinedReducerStore.dispatch({
              type: "LOGIN_SETUSER",
              currentUser: response.current_user,
              signedIn: response.signed_in,
              provider: response.provider
            })
          });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/util/login.js